<template>
    <div class="minidiv p-3 m-2">
         <b-row>
            <b-col  cols="3" class="bg-grey">
                <div class="p-2 text-left mr-2 result-col">{{ schedule.scheduled_category }}</div>
            </b-col>
            <b-col  cols="2" class="text-right">
                <div class="p-2 ml-3 result-col">{{ schedule.scheduled_institution_shortname }} UNILAG </div>
            </b-col>
            <b-col  cols="2" class="text-center">
                <div class="p-2 ml-2 result-col">{{ schedule.scheduled_institution_shortname }} UNILAG</div>
            </b-col>
            <b-col  cols="2" class="text-right">
                <div class="p-2 result-col">{{ schedule.scheduled_date | moment("ddd, DD MMM YYYY") }}</div>
            </b-col>
            <b-col  cols="2" class="text-center">
                <div class="p-2 result-col">{{ `${schedule.scheduled_date + ' ' + schedule.scheduled_time}` | moment("hh:mm a")}}</div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: ["schedule"],
    data() {
        return {
            randnum: Math.round(Math.random(1, 10) * 5),
            colorarr: ["red", "yellow", "green", "purple", "blue", " bluedepth"]
        };
    }
};
</script>

<style scoped>
.minidiv {
  background-color : #fbfbfb;
}
.result-col{
    font-size: 0.8rem
}
</style>
